/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {FITHGameConfig} from "../FITHGameConfig";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export interface IFITHSymbolStates extends ISymbolStates {
    noWin: ISymbolStateConfig;
    land: ISymbolStateConfig;
    multi: ISymbolStateConfig;
}

export class FITHReelSymbol extends StateReelSymbol {

    public fadeOutSymbol(): void {
        const finalScale: number = 0.5,
            fps: number = 30;

        // #143
        if (this.transform === null) {
            this.alpha = 0;

            return;
        }

        TweenLite.to(this.scale, (6 / fps), {x: finalScale, y: finalScale});
        TweenLite.to(this, (6 / fps), {alpha: 0});
    }

    // #248
    public onRemove(): void {
        TweenLite.killTweensOf(this);

        super.onRemove();
    }

    /**
     * @inheritDoc
     * @override To implement spine as State in some of the symbols.
     * @param timeline
     * @param newState
     * @param stateAnimation
     * @param delay
     */
    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        const spineStates: string[] = ["land"],
            landStateSymbols: string[] = ["B"],
            stateKey: string = newState.state.keyword;

        if (spineStates.indexOf(stateKey) !== -1 && landStateSymbols.indexOf(this.symName) !== -1) {
            timeline.add(() => new SpineTween((stateAnimation as any), 0, stateKey), delay);
            stateAnimation.alpha = 1;

            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if (newState.state.keyword === FITHGameConfig.instance.SYMBOL_STATES.win.keyword) {
            if (this.symName === ReelSymbolName.BONUS || this.symName === ReelSymbolName.WILD) {
                return;
            }

            const initialScale: number = 1.15,
                midScale:number = 1.1,
                origScale: number = 1,
                fps: number = 30;

            // applying animations as per #8
            timeline.add([
                () => this.scale.set(origScale),
                TweenLite.to(this.scale, (4 / fps), {x: initialScale, y: initialScale}),
                TweenLite.to(this.scale, (1 / fps), {x: midScale, y: midScale, delay: (4 / fps)}),
                TweenLite.to(this.scale, (5 / fps), {x: origScale, y: origScale, delay: (20 / fps)})
            ], delay);

            return;
        }
    }
}